// import omniFetch from 'omni-fetch'; 

// // The functional component is meant to call AEM feed for the page.

// const fetch = (url, options) => {
//     return new Promise((resolve, reject) => {
//         omniFetch(url, options).then(
//             response => {
//                 resolve(response);
//             },
//             err => reject(err)
//         );
//     });
// };

// This fucntion is used by the applications to call their respective CMS feed(Page feed)
// pageURL:             The url for the page they need for the application.
// DB Type:             And the type of DB they are using to fetch the feed.
// applicationHeaders:  If there is a need to add the custom headers.
//import cmsReaderSanity from '@idp/bit.dev/cmsreaderSanity'

 export const CMSReaderAem = async (pageURLorStubDataObject: any, pageObjectName:any, usingStub?: boolean, applicationHeaders?: any) => {
    let options = {};
    let readerResponse:any ={};
    const isUsingStub: boolean = usingStub;

    //Used for adding common headers throughout IDP
    // applicationHeaders ::: Gives the ability to the application teams to add their own headers.
    //const customHeaders: any = {'Content-Type': 'application/json'}; //  need to add default headers // TODO
    options = {
        //headers: applicationHeaders? applicationHeaders : '',
        timeout: 5000,
    };
        if(!isUsingStub) { 
            readerResponse = await fetch( pageURLorStubDataObject , options as RequestInit)
                .then((response: any) => {
                    if (response.status >= 400) {
                        throw new Error(`Bad response from server: ${response.status}`);
                    }   
                    console.info(`fetch successful`);
                    return response;
                }).then((response) => response ? response.json() : null)
                .then((resp) => resp)
                .catch(function (err) {console.info(` fetch fail ${err}`);
                    return Promise.reject(err); 
                });
            } else {
                readerResponse = pageURLorStubDataObject;
            }
            //console.log("RESPONSE::::::::", readerResponse)
            //let processedResponse = {};
            if( (!isUsingStub  && pageURLorStubDataObject.includes('idpcms')) || isUsingStub && pageURLorStubDataObject['idp-cms-feed']) {
                readerResponse = removeMasterObject(readerResponse); // only needed for 6.4 AEM feed
                readerResponse = feedObjectCorrectorAEM6dot4(readerResponse, 'AEM6dot4', pageObjectName);
            } else if( (!isUsingStub  && pageURLorStubDataObject.includes('dtvcms')) || (isUsingStub  && pageURLorStubDataObject[':items'])) {
                readerResponse = feedObjectCorrectorAEM6dot5(readerResponse, 'AEM6dot5');
            }

        return readerResponse;
    }


export const feedObjectCorrectorAEM6dot4 = (feedResp: any, typeOfDB?: string, pageName?:any) => {
    if (feedResp && pageName && feedResp['idp-cms-feed']) {
        let feedObject: any = feedResp['idp-cms-feed']?.[pageName];
        for(var addedObject in feedObject){
            if (feedObject.contentFragments.pageProperties) {
                feedObject.contentFragments.pageProperties[addedObject] = feedObject[addedObject]
                feedObject.contentFragments.pageProperties["dBType"] = typeOfDB;
                delete feedObject.contentFragments.pageProperties.contentFragments;
            } else { 
                feedObject.contentFragments[addedObject] = feedObject[addedObject];
                feedObject.contentFragments["dBType"] = typeOfDB;
                delete feedObject.contentFragments.contentFragments;
            }      
        }
        feedObject = feedObject.contentFragments;
        //console.log("Feed Object outer object added to pageprops 6.4 :::",feedObject )
        return feedObject;
    }
};


export const feedObjectCorrectorAEM6dot5 = (feedResp: any, typeOfDB?: string) => {
    if (feedResp && feedResp[':items'] && feedResp['index'])  {
        let feedObject: any = feedResp;
        feedObject[":items"] = {...feedObject[":items"], ...feedObject['index']}    
        // delete feedObject['index'];
        feedObject[":items"]['dBType'] = typeOfDB;
        //console.log("Feed Object outer object added to pageprops 6.5 :::",feedObject[":items"] )
        return feedObject[":items"];
    }
};

export const removeMasterObject = (jsonobj: any) => {

    let obj: any = jsonobj;
    if ( typeof obj !== 'boolean'
        && typeof obj !== 'number' && typeof obj !== 'string' 
        && typeof Object.keys(obj) !== 'undefined' && Object.keys(obj).length > 0) {
        const keys = Object.keys(obj);
        keys.map((key, val) => {
            if (obj[key] && obj[key].master) {
                Object.assign(obj[key], obj[key].master);
                delete obj[key].master;
                removeMasterObject(obj[key]);
            } else {
                if (typeof obj[key] !== 'string') {
                    // /console.log(typeof obj[key]);
                    removeMasterObject(obj[key]);
                }
            }
        });
    }
    return obj;
}